import { render, staticRenderFns } from "./VerificationFailure.vue?vue&type=template&id=6542a424&"
import script from "./VerificationFailure.vue?vue&type=script&lang=js&"
export * from "./VerificationFailure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports